import { Button, message, Row, Col, Alert } from "antd";
import "./Tab_Request.scss";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../../context/userContext";
import { OffersContext } from "../../../context/offersContext";
import { getOffersByShop, updateOffer } from "../../../services/user/user";
import {
  getProductsDetails,
  updateProduct,
} from "../../../services/productsDetails/productsDetails";
import {
  getHeaderByProductId,
  updateHeaderProductByKey,
} from "../../../services/headersProducts/headersProducts";
import { formatNumber } from "../../../helper/fomartNum";
import { priceNew } from "../../../helper/priceNew";

function Tab_Requests() {
  const { currentUser } = useContext(UserContext);
  const { updateOfferPrice } = useContext(OffersContext);

  const [offers, setOffers] = useState([]);
  const [productsMap, setProductsMap] = useState({});
  const [headersMap, setHeadersMap] = useState({});
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const fetchData = async () => {
      const data = await getOffersByShop(currentUser.username);
      setOffers(data);

      const productIds = data.map((o) => o.productId);
      const productsDetails = await Promise.all(
        productIds.map((id) => getProductsDetails(id))
      );

      const pMap = {};
      productsDetails.forEach((arr) => {
        if (arr.length > 0) pMap[arr[0].id] = arr[0];
      });
      setProductsMap(pMap);

      const headersDetails = await Promise.all(
        productIds.map((id) => getHeaderByProductId(id))
      );
      const hMap = {};
      headersDetails.forEach((h) => {
        if (h) hMap[h.key] = h;
      });
      setHeadersMap(hMap);
    };
    fetchData();
  }, [currentUser.username]);

  const handleAccept = async (offer) => {
    try {
      const expireTime = Date.now() + 24 * 60 * 60 * 1000;
      const product = productsMap[offer.productId];
      const header = Object.values(headersMap).find((h) =>
        h.products.some((p) => p.idProducts === offer.productId)
      );

      await updateProduct(offer.productId, {
        offer_price: offer.offerPrice,
        offer_expire_at: expireTime,
        price_old: offer.offerPrice,
        sales: 0,
      });

      if (header) {
        await updateHeaderProductByKey(
          header.key,
          offer.productId,
          offer.offerPrice
        );
      }

      await updateOffer(offer.id, { status: "accepted" });

      setOffers((prev) =>
        prev.map((o) => (o.id === offer.id ? { ...o, status: "accepted" } : o))
      );

      updateOfferPrice(offer.productId, offer.offerPrice);

      messageApi.open({
        type: "success",
        content: "Bạn đã chấp nhận đề nghị giá!",
      });
    } catch (err) {
      console.error(err);
      messageApi.open({
        type: "error",
        content: "Có lỗi xảy ra, vui lòng thử lại.",
      });
    }
  };

  const handleReject = async (offer) => {
    try {
      await updateOffer(offer.id, { status: "rejected" });
      setOffers((prev) =>
        prev.map((o) => (o.id === offer.id ? { ...o, status: "rejected" } : o))
      );
      messageApi.open({ type: "info", content: "Bạn đã từ chối đề nghị giá!" });
    } catch (err) {
      console.error(err);
      messageApi.open({
        type: "error",
        content: "Có lỗi xảy ra, vui lòng thử lại.",
      });
    }
  };

  return (
    <>
      {contextHolder}
      <div className="tab-requests">
        <Row gutter={[20, 20]}>
          {offers
            .slice()
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // mới nhất trước
            .map((offer) => {
              const product = productsMap[offer.productId];
              if (!product) return null;

              const displayPrice =
                offer.offerPrice ?? priceNew(product.price_old, product.sales);

              return (
                <Col xxl={4} xl={4} key={offer.id}>
                  <div className="req-item">
                    <div className="left">
                      <Link to={`/products/${product.id}`}>
                        <img
                          src={product.thumbnail1}
                          alt={product.name}
                          className="product-img"
                        />
                      </Link>
                      <div className="product-info">
                        <div className="product-name">{product.name}</div>
                        <div className="product-size">Size: {product.size}</div>
                        <div className="product-price">
                          Giá đề nghị: {formatNumber(displayPrice)}đ
                        </div>
                        <div className="original-price">
                          Giá gốc: {formatNumber(product.price_old)}đ
                        </div>
                        <div>Người đề nghị: {offer.username}</div>
                      </div>
                    </div>

                    <div className="right">
                      {offer.status === "pending" ? (
                        <div className="btn-choice">
                          <Button
                            onClick={() => handleAccept(offer)}
                            className="btn-accept"
                          >
                            Chấp nhận
                          </Button>
                          <Button onClick={() => handleReject(offer)} danger>
                            Từ chối
                          </Button>
                        </div>
                      ) : (
                        <div className={`status ${offer.status}`}>
                          {offer.status === "accepted" ? (
                            <Alert
                              message="Đã chấp nhận"
                              type="success"
                              showIcon
                            />
                          ) : (
                            <Alert message="Đã từ chối" type="error" showIcon />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
        </Row>
      </div>
    </>
  );
}

export default Tab_Requests;
